import React from 'react';
import { getOr } from 'lodash/fp';
import PropTypes from 'prop-types';
import S3Image from '../../S3Image';
import { AppConfig } from '../../../helpers/config';

const inventoryBucket = getOr('default', 'buckets.inventory', AppConfig);

const InventoryImage = ({ image, ...restProps }) => (
  <S3Image {...restProps} bucket={inventoryBucket} image={image} />
);

InventoryImage.propTypes = {
  image: PropTypes.string
};

InventoryImage.defaultProps = {
  image: null
};

export default InventoryImage;
